// extracted by mini-css-extract-plugin
export default {"header":"ProfileView_header__asKi3","referral":"ProfileView_referral__4IyoY","referralText":"ProfileView_referralText__FINhc"};